import React, { FC, ReactNode } from 'react'
import { useScroll } from 'Pages/landings/newLandings/common/hooks'
import { ImgComponent } from 'Pages/landings/newLandings/common/components'
import { ColorNames } from 'Pages/landings/newLandings/common/constants'
import { Wrapper, Block, Title, SubTitle, Button, BannerMobile } from './styled'

interface ComponentProps {
	srcBanner: string
	children: ReactNode
	subTitle: string | JSX.Element
	buttonScrollTo: string
	bannerMobileWebp?: string
	bannerMobileJpg?: string
	mobileImage?: () => JSX.Element
	buttonName?: string
	className?: string
	type?: string
}

export const BannerComponent: FC<ComponentProps> = ({
	srcBanner,
	children,
	subTitle,
	buttonScrollTo,
	bannerMobileWebp,
	bannerMobileJpg,
	mobileImage,
	buttonName = 'Оставить заявку',
	className,
	type = ColorNames.GHOST,
}) => {
	const { scrollIntoBlock } = useScroll()
	return (
		<Wrapper>
			{mobileImage?.() ? (
				mobileImage()
			) : (
				<ImgComponent srcSource={bannerMobileWebp}>
					<BannerMobile src={bannerMobileJpg} alt="" />
				</ImgComponent>
			)}
			<Block srcBanner={srcBanner} className={className}>
				<Title>{children}</Title>
				<SubTitle>{subTitle}</SubTitle>
				<Button
					type={type}
					measure="l"
					text={buttonName}
					onClick={() => scrollIntoBlock(`#${buttonScrollTo}`)}
				/>
			</Block>
		</Wrapper>
	)
}
